import(/* webpackMode: "eager" */ "/var/www/html/apps/grid-battles/src/assets/homepage/grid.png");
import(/* webpackMode: "eager" */ "/var/www/html/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/var/www/html/node_modules/next/dist/client/link.js")